import {useEffect} from 'react';
import {generateToastCss} from './generateToastCss';

export const useToastThemeConfig = (mode: 'light' | 'dark') => {
   useEffect(() => {
      const cfg = (window as any).themeColors; // TODO make type
      if (!cfg) return;

      const styleId = 'toast-theme-vars';
      let style = document.getElementById(styleId) as HTMLStyleElement;

      if (!style) {
         style = document.createElement('style');
         style.id = styleId;
         document.head.appendChild(style);
      }

      style.textContent = generateToastCss(cfg, mode);
   }, [mode]);
};
